import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Countdown } from "./Countdown";
import { PricingCards } from "./PricingCards";
import type { PlanId } from "../types/pricing";
type OfferProps = {
  time: {
    hours: number;
    minutes: number;
    seconds: number;
  };
  plan: PlanId;
  onPlanChange: (plan: PlanId) => void;
};
export function Offer({
  time,
  plan,
  onPlanChange
}: OfferProps) {
  const reduce = useReducedMotion();
  return <section id="precios" className="bg-cream" data-id="element-177" data-mp="tz3fywjsd75r">
      <div className="bg-wine text-paper" data-id="element-178" data-mp="p0a75hfg24bx">
        <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-5 py-6 md:flex-row md:justify-between md:gap-8 md:px-8 md:py-10" data-id="element-179" data-mp="p1l5h1q4ejvn">
          <div className="text-center md:text-left" data-id="element-180" data-mp="yxesjf1gtvro">
            <p className="flex items-center justify-center gap-2 text-xs font-semibold md:justify-start md:text-sm" data-id="element-181" data-mp="ywmwy47vby1e">
              <span className="relative flex h-2 w-2" data-id="element-182" data-mp="2fe0y2k3n5qui">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-goldSoft opacity-75 motion-reduce:hidden" data-id="element-183" data-mp="2acbiqs9dyr0m" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-goldSoft" data-id="element-184" data-mp="pml7vloyzhcs" />
              </span>
              Oferta en vivo · +$10.000 después
            </p>
            <h2 className="mt-1 font-display text-2xl md:mt-2 md:text-4xl" data-id="element-185" data-mp="ziwmwjfy2lax">Lanzamiento termina en</h2>
            <p className="mt-0.5 text-xs text-paper/70 md:mt-1 md:text-base" data-id="element-186" data-mp="13j74ktd3n05m">Y no vuelve a bajar.</p>
          </div>
          <Countdown {...time} data-id="element-187" data-mp="6rmsijsnp8d1" />
          <div className="w-full max-w-xs" data-id="element-188" data-mp="bsaqxqj7srha">
            <div className="flex justify-between text-xs md:text-sm" data-id="element-189" data-mp="btc0fqkl15ww">
              <span data-id="element-190" data-mp="fu5tszgsncx6">Cupos restantes</span>
              <span className="font-semibold text-goldSoft" data-id="element-191" data-mp="fsb3t6qo0um8">68% tomados</span>
            </div>
            <div className="mt-1.5 h-2 overflow-hidden rounded-full bg-paper/20 md:mt-2 md:h-2.5" role="progressbar" aria-valuenow={68} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos tomados" data-id="element-192" data-mp="kmffu4esfsu6">
              <motion.div className="h-full rounded-full bg-gold" initial={reduce ? {
              width: "68%"
            } : {
              width: 0
            }} whileInView={{
              width: "68%"
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-193" data-mp="3o84m9r4k4g5x" />
            </div>
          </div>
        </div>
      </div>
      <div className="mx-auto max-w-5xl px-5 py-8 md:px-8 md:py-14" data-id="element-194" data-mp="106z62x0fow4u">
        <div className="text-center" data-id="element-195" data-mp="cg39lml19cr9">
          <h2 className="font-display text-[26px] leading-tight text-forest md:text-4xl" data-id="element-196" data-mp="ch4usjvrjfmp">Elegí tu Megapack de Recetas Festivas</h2>
          <p className="mt-1 text-sm text-muted" data-id="element-197" data-mp="lhkstdtqluk6">Las dos opciones incluyen los 3 bonos completos.</p>
        </div>
        <div className="mt-5 md:mt-8" data-id="element-198" data-mp="hfg3grabnk3c">
          <PricingCards name="plan-principal" plan={plan} onPlanChange={onPlanChange} premiumNote="La opción más elegida por anfitrionas que quieren ir un paso más allá" data-id="element-199" data-mp="heeinv3i7j8f" />
        </div>
      </div>
    </section>;
}